import * as React from 'react';
import * as request from 'superagent';
import withStyles, { WithStyles, StyleRules, ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';
import { Paper, Typography } from '@material-ui/core';
import LoadingView from '~common/components/loading-view';
import ErrorView from '~common/components/error-view';
import DefinitionSection from '~common/form/definition-section';
import Renderers from '~common/lib/renderers';
import { setValueAtPath } from '~common/form/helper';
import * as jsonpatch from 'jsonpatch'


const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%',
	},
	actionsContainer: {
		marginBottom: 5
	},
	instructionContainer: {
		marginBottom: 5
	},
	formContainer: {
		paddingTop: 5
	},
	paperContainer: {
		padding: 10
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history?: any;
	entityDataField: string;
	returnURL?: string;
	match: any;
	readOnly?: any;
	preventCollapse?: boolean;
	viewTitle?: () => {}
}

type State = {
	status: 'loading' | 'ready' | 'complete';
	data: any;
	form: any;
	error?: any;
	policyMessages: Array<any>;
	sourceGridAttributes?: any;
};

class DefinitionSectionView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			data: {},
			form: {},
			status: 'loading',
			policyMessages: []
		};
	}

	handleMessage = (message: any) => {
		if (message && message.data.action) {
			switch ((message.data.action || "").toLowerCase()) {
				case "close":
					window.close()
					break;
				case "onreadystatechange":
					if (message && message.data && message.data.definition) {

						this.setState({
							form: message.data.definition,
							data: message.data.data || {},
							status: "ready",
							sourceGridAttributes: message.data.sourceGridAttributes
						}, () => {
							window.opener.postMessage({
								action: "expand",
								sectionGridAttributes: message.data.definition.popperAttributes.gridAttributes,
							}, window.location.origin)
						})
					}
					break;
				case "datadidupdate":
					if (message && message.data) {

						this.setState({
							data: message.data.data || {},
							status: "ready",
						})
					}
					break;
			}
		}
	}
	componentDidMount() {
		const self = this;
		// Listen for the supported messages
		window.addEventListener("beforeunload", function (event) {
			window.opener.postMessage({
				action: "reset",
			}, window.location.origin)
		});
		window.addEventListener("message", (event) => {
			self.handleMessage(event)
		}, false)

		if (window.opener) {
			window.opener.postMessage({ action: "ready" }, window.location.origin)
		} else {
			console.log("Why the heck are you here?")
		}

	}

	handleChangeAtPath = (path: string, value: any, fieldDef?: any) => {
		const msg: any = {
			path: this.state.form.key + path,
			value: value,
			fieldDef: fieldDef
		}
		window.opener.postMessage({action: "handlechangeatpath", data: msg}, window.location.origin)
	};

	clearMessagesAtPath = (path: string) => {
		const { policyMessages } = this.state
		if (policyMessages && policyMessages.length > 0) {
			const pm = policyMessages.reduce((acc, m) => {
				let mp = m.path
				if (mp.indexOf("/") == 0) {
					mp = mp.substring(1)
				}

				let op = path
				if (op.indexOf("/") == 0) {
					op = op.substring(1)
				}

				if (mp != op) {
					acc.push(m)
				}

				return acc
			}, [])

			this.setState({ policyMessages: pm })
		}
	}

	handleAPIError = (err: any, terminal?: boolean) => {
		var { policyMessages } = this.state
		try {
			policyMessages = JSON.parse(err.response.text)
		} catch (e) {
			console.error("Error Parsing Policy Messages", e)
		}
		this.setState({
			policyMessages: policyMessages,
			error: err
		})
	};


	onErrorViewClose = () => {
		this.setState({
			error: undefined
		});
	};

	render() {
		const { classes }: { classes: ClassNameMap } = this.props;
		var { history, readOnly, preventCollapse, entityDataField } = this.props
		const { status, data, error, policyMessages, form } = this.state;

		// use all the sapce
		if (form && form.definitions) {
			form.gridAttributes.lg = 12
			form.gridAttributes.md = 12
			form.gridAttributes.sm = 12
			form.gridAttributes.xl = 12
			form.gridAttributes.xs = 12
		}

		var formData = data
		if (entityDataField) {
			formData = data[form.key]
		}

		var errorView;
		if (error) {
			errorView = <ErrorView classes={{}} error={error} onClose={this.onErrorViewClose} />;
		}


		switch (status) {
			case 'loading':
				return (
					<div className={classes.container}>
						{errorView}
						<LoadingView classes={{}} />
					</div>
				);
			case 'ready':

				return (
					<div className={classes.container}>
						{errorView}
						{/* <div className={classes.formContainer}> */}
						<Paper className={classes.paperContainer}>
							<DefinitionSection
								data={formData}
								definition={form}
								path={''}
								policyMessages={policyMessages}
								onChangeAtPath={this.handleChangeAtPath}
								divSpacing={4}
								preventCollapse={true}
							/>
						</Paper>
						{/* </div> */}
					</div>
				);
		}
	}
}

export default withStyles(styles)(DefinitionSectionView);
